import {createSlice} from '@reduxjs/toolkit';
import {json} from "../../lib/appfuse-react/core/json";
import {Questionnaire} from "../../lib/appfuse-react/qnr";

const name = 'applicationSurvey';

const initialState = {
    assessment: null,
    activeStep: 0
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setAssessment(state, action) {
            state.assessment = json.toJSON(action.payload);
        },
        setActiveStep(state, action) {
            state.activeStep = action.payload;
        }
    }
});

export const { setAssessment, setActiveStep } = slice.actions;

export const selectAssessment = state =>  json.fromJSON(state[name].assessment, Questionnaire);
export const selectActiveStep= state => state[name].activeStep;

const applicationSurveyReducer = slice.reducer;

export default applicationSurveyReducer;